<template>
  <UTooltip :text="tooltip">
    <UButton
      v-bind="$attrs"
      @click="$emit('click', $event)"
    >
      <slot />
    </UButton>
  </UTooltip>
</template>

<script setup lang="ts">
defineProps({
  tooltip: {
    type: String,
    default: ''
  }
})

defineEmits(['click'])
</script>
